import { BvedCostType } from './BvedCostType.model';
import { CostGroupCategory } from '@eadsysteme/billingclient-v1';

const CategoryEnum = CostGroupCategory;

/**
 * Complete mapping of all BvedCostType enum values to their detailed data
 * Auto-generated from Java BvedCostType enum - Version 1.0
 *
 * Usage:
 * ```typescript
 * import { BvedCostTypeData } from './bved-cost-type.data';
 * import BvedCostTypeEnum = CostGroup.BvedCostTypeEnum;
 *
 * const costType = BvedCostTypeData[BvedCostTypeEnum.TAXES_INSURANCE];
 * console.log(costType.key); // "1.0.1"
 * console.log(costType.originalDesignation); // "Steuern/Versicherung"
 * ```
 */
export const BvedCostTypeData: Record<string, BvedCostType> = {
	TAXES_INSURANCE: {
		name: 'TAXES_INSURANCE',
		mainCategory: 1,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Steuern/Versicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '1.0.1',
	},
	TAXES: {
		name: 'TAXES',
		mainCategory: 1,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Steuern',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '1.0.2',
	},
	PROPERTY_TAX: {
		name: 'PROPERTY_TAX',
		mainCategory: 1,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Grundsteuer',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '1.0.3',
	},
	BASIC_CHARGES: {
		name: 'BASIC_CHARGES',
		mainCategory: 1,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Grundabgaben',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '1.0.4',
	},
	MUNICIPAL_CHARGES: {
		name: 'MUNICIPAL_CHARGES',
		mainCategory: 1,
		subCategory: 0,
		serial: 5,
		originalDesignation: 'Städt. Abgaben',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '1.0.5',
	},
	PROPERTY_FEES: {
		name: 'PROPERTY_FEES',
		mainCategory: 1,
		subCategory: 0,
		serial: 6,
		originalDesignation: 'Grundstücksgebühren',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '1.0.6',
	},
	COLD_WATER_PRICE_PER_M3: {
		name: 'COLD_WATER_PRICE_PER_M3',
		mainCategory: 2,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Kaltwasser Preis/m³',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.0.1',
	},
	COLD_WATER: {
		name: 'COLD_WATER',
		mainCategory: 2,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Kaltwasser',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.0.3',
	},
	DECALCIFICATION: {
		name: 'DECALCIFICATION',
		mainCategory: 2,
		subCategory: 0,
		serial: 5,
		originalDesignation: 'Entkalkung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.0.5',
	},
	WATER_SOFTENING_SYSTEM: {
		name: 'WATER_SOFTENING_SYSTEM',
		mainCategory: 2,
		subCategory: 0,
		serial: 6,
		originalDesignation: 'Enthärtungsanlage',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.0.6',
	},
	CHEMICAL_WATER_TREATMENT: {
		name: 'CHEMICAL_WATER_TREATMENT',
		mainCategory: 2,
		subCategory: 0,
		serial: 7,
		originalDesignation: 'Chem. Wasseraufbereitung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.0.7',
	},
	DRINKING_WATER_TEST: {
		name: 'DRINKING_WATER_TEST',
		mainCategory: 2,
		subCategory: 0,
		serial: 8,
		originalDesignation: 'Trinkwasserprüfung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.0.8',
	},
	COLD_WATER_INCL_ADDITIONAL_COSTS: {
		name: 'COLD_WATER_INCL_ADDITIONAL_COSTS',
		mainCategory: 2,
		subCategory: 0,
		serial: 9,
		originalDesignation: 'Kaltwasser inkl. Nebenkosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.0.9',
	},
	WASTEWATER: {
		name: 'WASTEWATER',
		mainCategory: 2,
		subCategory: 1,
		serial: 1,
		originalDesignation: 'Abwasser',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.1.1',
	},
	SEWAGE_TREATMENT_MAINTENANCE: {
		name: 'SEWAGE_TREATMENT_MAINTENANCE',
		mainCategory: 2,
		subCategory: 1,
		serial: 2,
		originalDesignation: 'Wartung Kläranlage',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.1.2',
	},
	WASTEWATER_PRICE_PER_M3: {
		name: 'WASTEWATER_PRICE_PER_M3',
		mainCategory: 2,
		subCategory: 1,
		serial: 3,
		originalDesignation: 'Abwasser Preis/m³',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.1.3',
	},
	PIT_EMPTYING: {
		name: 'PIT_EMPTYING',
		mainCategory: 2,
		subCategory: 1,
		serial: 4,
		originalDesignation: 'Grubenentleerung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.1.4',
	},
	LIFTING_STATION: {
		name: 'LIFTING_STATION',
		mainCategory: 2,
		subCategory: 1,
		serial: 5,
		originalDesignation: 'Hebeanlage',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.1.5',
	},
	SEWAGE_DISPOSAL: {
		name: 'SEWAGE_DISPOSAL',
		mainCategory: 2,
		subCategory: 1,
		serial: 7,
		originalDesignation: 'Fäkalienabfuhr',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.1.7',
	},
	RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_WATER: {
		name: 'RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_WATER',
		mainCategory: 2,
		subCategory: 1,
		serial: 8,
		originalDesignation: 'Miete/Wartung Geräte weitere Messdienstfirma',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '2.1.8',
	},
	COLD_AND_WASTEWATER: {
		name: 'COLD_AND_WASTEWATER',
		mainCategory: 3,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Kalt- u. Abwasser',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '3.0.1',
	},
	COLD_AND_WASTEWATER_PRICE_PER_M3: {
		name: 'COLD_AND_WASTEWATER_PRICE_PER_M3',
		mainCategory: 3,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Kalt- und Abwasser Preis/m³',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '3.0.2',
	},
	COLD_WASTEWATER_ADDITIONAL_COSTS: {
		name: 'COLD_WASTEWATER_ADDITIONAL_COSTS',
		mainCategory: 3,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Kaltwasser /Abwasser./Nebenkosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '3.0.3',
	},
	RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_COMBINED: {
		name: 'RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_COMBINED',
		mainCategory: 3,
		subCategory: 2,
		serial: 1,
		originalDesignation: 'Miete/Wartung Geräte weitere Messdienstfirma',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '3.2.1',
	},
	SERVICE_COSTS_EXTERNAL_MEASURING_COMBINED: {
		name: 'SERVICE_COSTS_EXTERNAL_MEASURING_COMBINED',
		mainCategory: 3,
		subCategory: 2,
		serial: 2,
		originalDesignation: 'Servicekosten weitere Messdienstfirma',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '3.2.2',
	},
	ENERGY_BILL_HEATING: {
		name: 'ENERGY_BILL_HEATING',
		mainCategory: 4,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Energierechnung',
		categories: [CategoryEnum.HEAT_ENERGY],
		key: '4.0.1',
	},
	REMAINDER_FROM_PREVIOUS_YEAR_HEATING: {
		name: 'REMAINDER_FROM_PREVIOUS_YEAR_HEATING',
		mainCategory: 4,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Rest Vorjahr/Jahresende',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.0.4',
	},
	OPERATING_COSTS_HEATING: {
		name: 'OPERATING_COSTS_HEATING',
		mainCategory: 4,
		subCategory: 1,
		serial: 2,
		originalDesignation: 'Betriebskosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.1.2',
	},
	OPERATING_ELECTRICITY_HEATING: {
		name: 'OPERATING_ELECTRICITY_HEATING',
		mainCategory: 4,
		subCategory: 1,
		serial: 3,
		originalDesignation: 'Betriebsstrom',
		categories: [CategoryEnum.HEATING_OPERATION, CategoryEnum.ANCILLARY_SERVICES],
		key: '4.1.3',
	},
	RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_HEATING: {
		name: 'RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_HEATING',
		mainCategory: 4,
		subCategory: 2,
		serial: 1,
		originalDesignation: 'Miete/Wartung Geräte weitere Messdienstfirma',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.2.1',
	},
	SERVICE_COSTS_EXTERNAL_MEASURING_HEATING: {
		name: 'SERVICE_COSTS_EXTERNAL_MEASURING_HEATING',
		mainCategory: 4,
		subCategory: 2,
		serial: 2,
		originalDesignation: 'Servicekosten weitere Messdienstfirma',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.2.2',
	},
	OPERATING_COSTS_HEATING_DETAILED: {
		name: 'OPERATING_COSTS_HEATING_DETAILED',
		mainCategory: 4,
		subCategory: 2,
		serial: 3,
		originalDesignation: 'Bedienungskosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.2.3',
	},
	EMISSION_MEASUREMENT_HEATING: {
		name: 'EMISSION_MEASUREMENT_HEATING',
		mainCategory: 4,
		subCategory: 2,
		serial: 5,
		originalDesignation: 'Emissionsmessung',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.2.5',
	},
	CHIMNEY_SWEEP_HEATING: {
		name: 'CHIMNEY_SWEEP_HEATING',
		mainCategory: 4,
		subCategory: 2,
		serial: 8,
		originalDesignation: 'Kaminfeger',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.2.8',
	},
	TANK_CLEANING_HEATING: {
		name: 'TANK_CLEANING_HEATING',
		mainCategory: 4,
		subCategory: 2,
		serial: 13,
		originalDesignation: 'Tankreinigung',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.2.13',
	},
	MAINTENANCE_COSTS_HEATING: {
		name: 'MAINTENANCE_COSTS_HEATING',
		mainCategory: 4,
		subCategory: 2,
		serial: 16,
		originalDesignation: 'Wartungskosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '4.2.16',
	},
	ENERGY_BILL_HOT_WATER: {
		name: 'ENERGY_BILL_HOT_WATER',
		mainCategory: 5,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Energierechnung',
		categories: [CategoryEnum.HEAT_ENERGY],
		key: '5.0.1',
	},
	REMAINDER_FROM_PREVIOUS_YEAR_HOT_WATER: {
		name: 'REMAINDER_FROM_PREVIOUS_YEAR_HOT_WATER',
		mainCategory: 5,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Rest Vorjahr/Jahresende',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.0.4',
	},
	OPERATING_COSTS_HOT_WATER: {
		name: 'OPERATING_COSTS_HOT_WATER',
		mainCategory: 5,
		subCategory: 1,
		serial: 2,
		originalDesignation: 'Betriebskosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.1.2',
	},
	OPERATING_ELECTRICITY_HOT_WATER: {
		name: 'OPERATING_ELECTRICITY_HOT_WATER',
		mainCategory: 5,
		subCategory: 1,
		serial: 3,
		originalDesignation: 'Betriebsstrom',
		categories: [CategoryEnum.HEATING_OPERATION, CategoryEnum.ANCILLARY_SERVICES],
		key: '5.1.3',
	},
	COLD_WATER_FOR_HOT_WATER: {
		name: 'COLD_WATER_FOR_HOT_WATER',
		mainCategory: 5,
		subCategory: 1,
		serial: 4,
		originalDesignation: 'Kaltwasser für Warmwasser',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.1.4',
	},
	COLD_WATER_FOR_HOT_WATER_PER_CCM: {
		name: 'COLD_WATER_FOR_HOT_WATER_PER_CCM',
		mainCategory: 5,
		subCategory: 1,
		serial: 5,
		originalDesignation: 'Kaltwasser für Warmwasser pro ccm',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.1.5',
	},
	LEGIONELLA_TEST: {
		name: 'LEGIONELLA_TEST',
		mainCategory: 5,
		subCategory: 1,
		serial: 6,
		originalDesignation: 'Legionellenprüfung',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.1.6',
	},
	RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_HOT_WATER: {
		name: 'RENTAL_MAINTENANCE_DEVICES_EXTERNAL_MEASURING_HOT_WATER',
		mainCategory: 5,
		subCategory: 2,
		serial: 1,
		originalDesignation: 'Miete/Wartung Geräte weitere Messdienstfirma',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.2.1',
	},
	SERVICE_COSTS_EXTERNAL_MEASURING_HOT_WATER: {
		name: 'SERVICE_COSTS_EXTERNAL_MEASURING_HOT_WATER',
		mainCategory: 5,
		subCategory: 2,
		serial: 2,
		originalDesignation: 'Servicekosten weitere Messdienstfirma',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.2.2',
	},
	MAINTENANCE_COSTS_HOT_WATER: {
		name: 'MAINTENANCE_COSTS_HOT_WATER',
		mainCategory: 5,
		subCategory: 2,
		serial: 16,
		originalDesignation: 'Wartungskosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '5.2.16',
	},
	ENERGY_BILL: {
		name: 'ENERGY_BILL',
		mainCategory: 6,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Energierechnung',
		categories: [CategoryEnum.HEAT_ENERGY],
		key: '6.0.1',
	},
	REMAINDER_FROM_PREVIOUS_YEAR: {
		name: 'REMAINDER_FROM_PREVIOUS_YEAR',
		mainCategory: 6,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Rest Vorjahr/Jahresende',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.0.4',
	},
	OPERATING_COSTS: {
		name: 'OPERATING_COSTS',
		mainCategory: 6,
		subCategory: 2,
		serial: 2,
		originalDesignation: 'Betriebskosten /Bedienungskosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.2',
	},
	OPERATING_ELECTRICITY: {
		name: 'OPERATING_ELECTRICITY',
		mainCategory: 6,
		subCategory: 2,
		serial: 3,
		originalDesignation: 'Betriebsstrom',
		categories: [CategoryEnum.HEATING_OPERATION, CategoryEnum.ANCILLARY_SERVICES],
		key: '6.2.3',
	},
	OPERATING_ELECTRICITY_FLAT_RATE: {
		name: 'OPERATING_ELECTRICITY_FLAT_RATE',
		mainCategory: 6,
		subCategory: 2,
		serial: 4,
		originalDesignation: 'Betriebsstrom pauschal',
		categories: [CategoryEnum.HEATING_OPERATION, CategoryEnum.ANCILLARY_SERVICES],
		key: '6.2.4',
	},
	EMISSION_MEASUREMENT: {
		name: 'EMISSION_MEASUREMENT',
		mainCategory: 6,
		subCategory: 2,
		serial: 5,
		originalDesignation: 'Emissionsmessung',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.5',
	},
	OPENING_BILL: {
		name: 'OPENING_BILL',
		mainCategory: 6,
		subCategory: 2,
		serial: 6,
		originalDesignation: 'Eröffnungsrechnung',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.6',
	},
	HEATING_COSTS: {
		name: 'HEATING_COSTS',
		mainCategory: 6,
		subCategory: 2,
		serial: 7,
		originalDesignation: 'Heizkosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.7',
	},
	CHIMNEY_SWEEP: {
		name: 'CHIMNEY_SWEEP',
		mainCategory: 6,
		subCategory: 2,
		serial: 8,
		originalDesignation: 'Kaminfeger',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.8',
	},
	EXHAUST_SYSTEM_COSTS: {
		name: 'EXHAUST_SYSTEM_COSTS',
		mainCategory: 6,
		subCategory: 2,
		serial: 9,
		originalDesignation: 'Kosten d. Abgasanlage',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.9',
	},
	MANAGEMENT_SURCHARGE: {
		name: 'MANAGEMENT_SURCHARGE',
		mainCategory: 6,
		subCategory: 2,
		serial: 10,
		originalDesignation: 'Regieaufschlag',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.10',
	},
	CLEANING_COSTS: {
		name: 'CLEANING_COSTS',
		mainCategory: 6,
		subCategory: 2,
		serial: 11,
		originalDesignation: 'Reinigungskosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '6.2.11',
	},
	TANK_CLEANING: {
		name: 'TANK_CLEANING',
		mainCategory: 6,
		subCategory: 2,
		serial: 13,
		originalDesignation: 'Tankreinigung',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.13',
	},
	TANK_PROTECTION_AGENT: {
		name: 'TANK_PROTECTION_AGENT',
		mainCategory: 6,
		subCategory: 2,
		serial: 14,
		originalDesignation: 'Tankschutzmittel',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.14',
	},
	TUV_FEES_OIL_TANK: {
		name: 'TUV_FEES_OIL_TANK',
		mainCategory: 6,
		subCategory: 2,
		serial: 15,
		originalDesignation: 'TÜV-Gebühren Öltank',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.15',
	},
	MAINTENANCE_COSTS: {
		name: 'MAINTENANCE_COSTS',
		mainCategory: 6,
		subCategory: 2,
		serial: 16,
		originalDesignation: 'Wartungskosten',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.16',
	},
	INSURANCE_HEATING: {
		name: 'INSURANCE_HEATING',
		mainCategory: 6,
		subCategory: 2,
		serial: 17,
		originalDesignation: 'Versicherung',
		categories: [CategoryEnum.HEATING_OPERATION, CategoryEnum.ANCILLARY_SERVICES],
		key: '6.2.17',
	},
	SERVICE_COSTS_EXTERNAL_MEASURING: {
		name: 'SERVICE_COSTS_EXTERNAL_MEASURING',
		mainCategory: 6,
		subCategory: 2,
		serial: 18,
		originalDesignation: 'Servicekosten weiterer Messdienstfirma',
		categories: [CategoryEnum.HEATING_OPERATION],
		key: '6.2.18',
	},
	ELEVATOR: {
		name: 'ELEVATOR',
		mainCategory: 7,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Aufzug',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '7.0.1',
	},
	ELEVATOR_OPERATING_COSTS: {
		name: 'ELEVATOR_OPERATING_COSTS',
		mainCategory: 7,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Betriebskosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '7.0.2',
	},
	ELEVATOR_MAINTENANCE: {
		name: 'ELEVATOR_MAINTENANCE',
		mainCategory: 7,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Wartung für Aufzug',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '7.0.3',
	},
	STREET_CLEANING: {
		name: 'STREET_CLEANING',
		mainCategory: 8,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Straßenreinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '8.0.1',
	},
	GARBAGE_COLLECTION: {
		name: 'GARBAGE_COLLECTION',
		mainCategory: 8,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Müllabfuhr',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '8.0.2',
	},
	GARBAGE_BAGS: {
		name: 'GARBAGE_BAGS',
		mainCategory: 8,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Müllsäcke',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '8.0.3',
	},
	CLEANING: {
		name: 'CLEANING',
		mainCategory: 9,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Reinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '9.0.1',
	},
	HALLWAY_CLEANING: {
		name: 'HALLWAY_CLEANING',
		mainCategory: 9,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Flurreinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '9.0.2',
	},
	COURTYARD_CLEANING: {
		name: 'COURTYARD_CLEANING',
		mainCategory: 9,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Hofreinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '9.0.3',
	},
	HOUSE_CLEANING: {
		name: 'HOUSE_CLEANING',
		mainCategory: 9,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Hausreinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '9.0.4',
	},
	STAIRCASE_CLEANING: {
		name: 'STAIRCASE_CLEANING',
		mainCategory: 9,
		subCategory: 0,
		serial: 5,
		originalDesignation: 'Treppenhausreinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '9.0.5',
	},
	PEST_CONTROL: {
		name: 'PEST_CONTROL',
		mainCategory: 9,
		subCategory: 0,
		serial: 6,
		originalDesignation: 'Ungezieferbekämpfung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '9.0.6',
	},
	GARDEN_MAINTENANCE: {
		name: 'GARDEN_MAINTENANCE',
		mainCategory: 10,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Gartenpflege',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '10.0.1',
	},
	OUTDOOR_FACILITIES: {
		name: 'OUTDOOR_FACILITIES',
		mainCategory: 10,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Außenanlagen',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '10.0.2',
	},
	GARDEN_WATER: {
		name: 'GARDEN_WATER',
		mainCategory: 10,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Gartenwasser',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '10.0.3',
	},
	LIGHTING: {
		name: 'LIGHTING',
		mainCategory: 11,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Beleuchtung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '11.0.1',
	},
	HALLWAY_LIGHTING: {
		name: 'HALLWAY_LIGHTING',
		mainCategory: 11,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Flurbeleuchtung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '11.0.2',
	},
	COURTYARD_LIGHTING: {
		name: 'COURTYARD_LIGHTING',
		mainCategory: 11,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Hofbeleuchtung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '11.0.3',
	},
	GENERAL_ELECTRICITY: {
		name: 'GENERAL_ELECTRICITY',
		mainCategory: 11,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Allgemeinstrom',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '11.0.4',
	},
	PARKING_LOT_LIGHTING: {
		name: 'PARKING_LOT_LIGHTING',
		mainCategory: 11,
		subCategory: 0,
		serial: 5,
		originalDesignation: 'Parkplatzbeleuchtung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '11.0.5',
	},
	ARCADE_LIGHTING: {
		name: 'ARCADE_LIGHTING',
		mainCategory: 11,
		subCategory: 0,
		serial: 6,
		originalDesignation: 'Arkadenbeleuchtung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '11.0.6',
	},
	CHIMNEY_CLEANING: {
		name: 'CHIMNEY_CLEANING',
		mainCategory: 12,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Kaminreinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '12.0.1',
	},
	INSURANCE: {
		name: 'INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Versicherungen',
		categories: [CategoryEnum.HEATING_OPERATION, CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.1',
	},
	FIRE_INSURANCE: {
		name: 'FIRE_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Feuerversicherungen',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.2',
	},
	WATER_DAMAGE_INSURANCE: {
		name: 'WATER_DAMAGE_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Wasserschadenversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.3',
	},
	STORM_DAMAGE_INSURANCE: {
		name: 'STORM_DAMAGE_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Unwetterversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.4',
	},
	LIABILITY_INSURANCE: {
		name: 'LIABILITY_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 5,
		originalDesignation: 'Haftpflichtversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.5',
	},
	BUILDING_INSURANCE: {
		name: 'BUILDING_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 6,
		originalDesignation: 'Gebäudeversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.6',
	},
	GLASS_INSURANCE: {
		name: 'GLASS_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 7,
		originalDesignation: 'Glasversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.7',
	},
	WATER_BODY_DAMAGE_LIABILITY: {
		name: 'WATER_BODY_DAMAGE_LIABILITY',
		mainCategory: 13,
		subCategory: 0,
		serial: 8,
		originalDesignation: 'Gewässer Schaden Haftpflicht',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.8',
	},
	BUILDING_CONDUCTION_INSURANCE: {
		name: 'BUILDING_CONDUCTION_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 9,
		originalDesignation: 'Gebäudeleit. Versicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.9',
	},
	BUILDING_LIABILITY: {
		name: 'BUILDING_LIABILITY',
		mainCategory: 13,
		subCategory: 0,
		serial: 10,
		originalDesignation: 'Gebäudehaftpflicht',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.10',
	},
	BUILDING_FIRE_INSURANCE: {
		name: 'BUILDING_FIRE_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 11,
		originalDesignation: 'Gebäudefeuerversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.11',
	},
	OIL_TANK_INSURANCE: {
		name: 'OIL_TANK_INSURANCE',
		mainCategory: 13,
		subCategory: 0,
		serial: 12,
		originalDesignation: 'Öltankversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.12',
	},
	STORM_DAMAGE_INSURANCE_BUILDING: {
		name: 'STORM_DAMAGE_INSURANCE_BUILDING',
		mainCategory: 13,
		subCategory: 0,
		serial: 13,
		originalDesignation: 'Sturmschadenversicherung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '13.0.13',
	},
	CARETAKER_WAGES: {
		name: 'CARETAKER_WAGES',
		mainCategory: 14,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Hauswartlohn',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '14.0.1',
	},
	SNOW_REMOVAL: {
		name: 'SNOW_REMOVAL',
		mainCategory: 14,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Schneebeseitigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '14.0.2',
	},
	CARETAKER: {
		name: 'CARETAKER',
		mainCategory: 14,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Hausmeister',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '14.0.3',
	},
	COMMUNITY_ANTENNA: {
		name: 'COMMUNITY_ANTENNA',
		mainCategory: 15,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Gemeinschaftsantenne',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '15.0.1',
	},
	WASHING_MACHINE: {
		name: 'WASHING_MACHINE',
		mainCategory: 16,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Waschmaschine',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '16.0.1',
	},
	BANK_FEES: {
		name: 'BANK_FEES',
		mainCategory: 17,
		subCategory: 0,
		serial: 1,
		originalDesignation: 'Bankgebühren',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.1',
	},
	BUILDING_LEASE: {
		name: 'BUILDING_LEASE',
		mainCategory: 17,
		subCategory: 0,
		serial: 2,
		originalDesignation: 'Erbbauzins',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.2',
	},
	MAINTENANCE_RESERVES: {
		name: 'MAINTENANCE_RESERVES',
		mainCategory: 17,
		subCategory: 0,
		serial: 3,
		originalDesignation: 'Instandsetzung-Rücklagen',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.3',
	},
	REPAIRS: {
		name: 'REPAIRS',
		mainCategory: 17,
		subCategory: 0,
		serial: 4,
		originalDesignation: 'Reparaturen',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.4',
	},
	HEATER_FAN: {
		name: 'HEATER_FAN',
		mainCategory: 17,
		subCategory: 0,
		serial: 5,
		originalDesignation: 'Heizlüfter',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.5',
	},
	SWIMMING_POOL: {
		name: 'SWIMMING_POOL',
		mainCategory: 17,
		subCategory: 0,
		serial: 6,
		originalDesignation: 'Schwimmbad',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.6',
	},
	ELECTRICITY: {
		name: 'ELECTRICITY',
		mainCategory: 17,
		subCategory: 0,
		serial: 7,
		originalDesignation: 'Strom',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.7',
	},
	GARAGE_COSTS: {
		name: 'GARAGE_COSTS',
		mainCategory: 17,
		subCategory: 0,
		serial: 8,
		originalDesignation: 'Garagenkosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.8',
	},
	PARKING_COSTS: {
		name: 'PARKING_COSTS',
		mainCategory: 17,
		subCategory: 0,
		serial: 9,
		originalDesignation: 'Parkplatzkosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.9',
	},
	ADMINISTRATION_MAINTENANCE: {
		name: 'ADMINISTRATION_MAINTENANCE',
		mainCategory: 17,
		subCategory: 0,
		serial: 10,
		originalDesignation: 'Verwaltung /Instandhaltung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.10',
	},
	COLLECTION_FEES: {
		name: 'COLLECTION_FEES',
		mainCategory: 17,
		subCategory: 0,
		serial: 11,
		originalDesignation: 'Inkassogebühren',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.11',
	},
	ADMINISTRATION_COSTS: {
		name: 'ADMINISTRATION_COSTS',
		mainCategory: 17,
		subCategory: 0,
		serial: 12,
		originalDesignation: 'Verwaltungskosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.12',
	},
	RAINWATER: {
		name: 'RAINWATER',
		mainCategory: 17,
		subCategory: 0,
		serial: 13,
		originalDesignation: 'Regenwasser',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.13',
	},
	EMERGENCY_POWER_SYSTEM: {
		name: 'EMERGENCY_POWER_SYSTEM',
		mainCategory: 17,
		subCategory: 0,
		serial: 14,
		originalDesignation: 'Notstrom-Anlage',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.14',
	},
	FIRE_EXTINGUISHING_SYSTEM: {
		name: 'FIRE_EXTINGUISHING_SYSTEM',
		mainCategory: 17,
		subCategory: 0,
		serial: 15,
		originalDesignation: 'Löschanlage',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.15',
	},
	LAWYER_COURT_COSTS: {
		name: 'LAWYER_COURT_COSTS',
		mainCategory: 17,
		subCategory: 0,
		serial: 16,
		originalDesignation: 'Anwalts-/Gerichtskosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.16',
	},
	VENTILATION_BASIC_COSTS: {
		name: 'VENTILATION_BASIC_COSTS',
		mainCategory: 17,
		subCategory: 0,
		serial: 17,
		originalDesignation: 'Grundkosten Lüftung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.17',
	},
	FIRE_EXTINGUISHER_MAINTENANCE: {
		name: 'FIRE_EXTINGUISHER_MAINTENANCE',
		mainCategory: 17,
		subCategory: 0,
		serial: 18,
		originalDesignation: 'Feuerlöscher-Wartung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.18',
	},
	SECURITY_COSTS: {
		name: 'SECURITY_COSTS',
		mainCategory: 17,
		subCategory: 0,
		serial: 19,
		originalDesignation: 'Bewachungskosten',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.19',
	},
	UNDERGROUND_GARAGE_MAINTENANCE: {
		name: 'UNDERGROUND_GARAGE_MAINTENANCE',
		mainCategory: 17,
		subCategory: 0,
		serial: 20,
		originalDesignation: 'Tiefgarage Wartung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.20',
	},
	GARAGE_CLEANING: {
		name: 'GARAGE_CLEANING',
		mainCategory: 17,
		subCategory: 0,
		serial: 21,
		originalDesignation: 'Garagenreinigung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.21',
	},
	TV_CONNECTION_FEES: {
		name: 'TV_CONNECTION_FEES',
		mainCategory: 17,
		subCategory: 0,
		serial: 22,
		originalDesignation: 'Fernsehanschlussgebühr',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.22',
	},
	TV_CABLE_FEES: {
		name: 'TV_CABLE_FEES',
		mainCategory: 17,
		subCategory: 0,
		serial: 23,
		originalDesignation: 'Fernsehkabelgebühr',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.23',
	},
	SURFACE_WATER: {
		name: 'SURFACE_WATER',
		mainCategory: 17,
		subCategory: 0,
		serial: 24,
		originalDesignation: 'Oberflächenwasser',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.24',
	},
	FEES_POSTAGE: {
		name: 'FEES_POSTAGE',
		mainCategory: 17,
		subCategory: 0,
		serial: 25,
		originalDesignation: 'Gebühren/Porto',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.25',
	},
	MAINTENANCE_GENERAL: {
		name: 'MAINTENANCE_GENERAL',
		mainCategory: 17,
		subCategory: 0,
		serial: 26,
		originalDesignation: 'Instandhaltung',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.0.26',
	},
	SMOKE_DETECTOR_MAINTENANCE_EXTERNAL: {
		name: 'SMOKE_DETECTOR_MAINTENANCE_EXTERNAL',
		mainCategory: 17,
		subCategory: 2,
		serial: 1,
		originalDesignation: 'Wartung Geräte Fremd Rauchwarnmelder',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.2.1',
	},
	SMOKE_DETECTOR_FUNCTION_TEST: {
		name: 'SMOKE_DETECTOR_FUNCTION_TEST',
		mainCategory: 17,
		subCategory: 2,
		serial: 2,
		originalDesignation: 'Funktionsprüfung Rauchwarnmelder',
		categories: [CategoryEnum.ANCILLARY_SERVICES],
		key: '17.2.2',
	},
};
